import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full" }

import { PropType } from 'vue';
import { IGalleryImage } from '@/lib';
import ImagePreview from './BaseImagePreview.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseImagesGallery',
  props: {
  images: {
    type: Array as PropType<Array<IGalleryImage>>,
    default: () => []
  },
  modelValue: {
    type: Number,
    default: 0
  }
},
  emits: ["update:modelValue"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (image, index) => {
      return (_openBlock(), _createBlock(ImagePreview, {
        key: index,
        class: "mr-4",
        "image-url": image.thumbnailUri ? image.thumbnailUri : image.image,
        text: __props.modelValue === index ? null : image.placeholder,
        onClick: ($event: any) => (_ctx.$emit('update:modelValue', index))
      }, null, 8, ["image-url", "text", "onClick"]))
    }), 128))
  ]))
}
}

})